<template>
  <div class="cart-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.cart') }}</span>
    </div>
    <div class="page-title">{{ getPageTitle }}</div>
    <div class="page-container">

      <CartStep1 
        v-show="step=='cart'"
        :cars="cars" 
        @cartChange="handleCartChange"
        :totalCount="getTotalCount"
        :shipPrice="getShipPrice"
        :couponPrice="getCouponPrice"
        :totalPrice="getTotalPrice"
        :useCouponTemp.sync="useCouponTemp"
        @changeCoupon="handleChangeCoupon"
        @next="handelNext"
        ref="step1"
      />
      <CartStep2
        v-show="step=='ship'"
        :cars="cars" 
        :totalCount="getTotalCount"
        :shipPrice="getShipPrice"
        :couponPrice="getCouponPrice"
        :totalPrice="getTotalPrice"
        @next="handelNext"
        ref="step2"
      />
      <CartStep3
        v-show="step=='pay'"
        :cars="cars" 
        :totalCount="getTotalCount"
        :shipPrice="getShipPrice"
        :couponPrice="getCouponPrice"
        :totalPrice="getTotalPrice"
        @next="handelNext"
        ref="step3"
      />
      <CartStep4
        v-show="step=='success'"
        @next="handelNext"
        ref="step4"
      />
      
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu'
import { mapState } from 'vuex';
import { Loading } from 'element-ui';
import { formatPrice } from '../../utils/tools.js'
import { cartsConfirm, cartsCheckout, getCart, getDiscounts, toteFees }  from '@/api'
import moment from "moment";

import CartStep1 from './components/CartStep1.vue'
import CartStep2 from './components/CartStep2.vue'
import CartStep3 from './components/CartStep3.vue'
import CartStep4 from './components/CartStep4.vue'


  export default {
    name: 'cart',
    components: {
      userSideMenu,
      CartStep1,
      CartStep2,
      CartStep3,
      CartStep4,
    },
    data() {
      return {
        cars: [],
        step: 'cart',
        // freeAmt: 0, // 免运价格(api調整後目前用不到)
        toteFee: 0, // 运费
        couponList: '', // 优惠卷列表
        useCouponTemp: '', // 输入框输入的优惠卷
        couponCostPrice: 0, // 优惠卷折扣了多少钱
        toteFeeRange: [], // 運費計算的規則
      }
    },
    computed: {
      ...mapState(['userInfo']),
      getPageTitle() {
        switch (this.step) {
          case 'cart':
            return this.$t('cart_page.step1');
            break;
          case 'ship':
            return this.$t('cart_page.step2');
            break;
          case 'pay':
            return this.$t('cart_page.step3');
            break;
          case 'success':
            return this.$t('cart_page.step4');
            break;
          default:
            return this.$t('cart_page.step5');
            break;
        }
      },
      // 小计
      getTotalCount() {
        // 计算一下购物车里面的价格
        return this.doTotalCount();
      },
      // 运费
      getShipPrice() {
        // 需判断价格是否超过免运的价格，如果没有就加入运费
        return this.doShipPrice();
      },
      // 优惠卷
      getCouponPrice() {
        const costPrice = this.doCouponPrice();
        if(costPrice>0) {
          const formatCostPrice = formatPrice(costPrice);
          const costPercent = Math.floor(costPrice/this.doTotalCount()*100);
          return `-${costPercent}%(${formatCostPrice})`;
        }else{
          return '0';
        }
        
      },
      // 总计
      getTotalPrice() {
        return this.doTotalCount() + this.doShipPrice() - this.doCouponPrice();
      }
    },
    created() {
      
    },
    mounted() {
      this.$nextTick(() => {
        this.getDetail();
        const tote_fee_range = toteFees().then(res => {
          console.log('tote_fee_range');
          console.log(res);
          res.list.sort(function (a, b) {
            return b.freeAmt - a.freeAmt;
          });
          console.log(res.list);
          this.toteFeeRange = res.list;
        });
        
      });
    },
    methods: {
      async getDetail() {
        let loadingInstance = Loading.service({ target: this.$refs.cartlist });
        const { cars, freeAmt, toteFee } = await getCart();
        console.log('cars',cars);
        const newCars = cars.map(item => { return { ...item, checked: false, adjust: false }});
        this.cars = newCars;
        // this.freeAmt = freeAmt; // 免运价格(api調整後目前用不到)
        // this.toteFee = toteFee; // 运费(api調整後目前用不到)
        loadingInstance.close();
      },
      handleCartChange(cars) {
        this.cars = cars;
      },
      async handelNext(step) {
        const step2data = this.$refs.step2.formdata;
        const step3data = this.$refs.step3;
        const user = this.userInfo.user;
        let postdata = {};
        console.log('user');
        console.log('name',user.name);
        console.log('mobile',user.mobile);
        console.log('zip',user.zip);
        console.log('province',user.province);
        console.log('city',user.city);
        console.log('area',user.area);
        console.log('addr',user.addr);
        
        if(!user.name || !user.mobile || !user.zip || !user.province || !user.city || !user.area || !user.address) {
          this.$message({
            message: this.$t('alert_message.to_edit_userinfo'),
            type: "warning",
          })
          return;
        }

        let loadingInstance = this.$loading();
        switch (step) {
          case 'pay':
            // 前往结帐页面
            postdata = {
              store_id: user.store_id,
              member_id: user.id,
              orderdate: moment(new Date()).format("YYYY-MM-DD"),
              // toteType: step2data.toteType,
              toteTime: step2data.shipTime,
              toteDate: step2data.shipDate=='1'?moment(step2data.date).format("YYYY-MM-DD"):'',
              toteFee: this.doShipPrice(),
              sumprice: this.getTotalCount,
              discount_no: this.useCouponTemp,
              discount_batch_amt: this.couponCostPrice,
              totalAmt: this.getTotalPrice,
              name: step2data.username,
              telphone: step2data.phone,
              mobile: step2data.mobile,
              country_id: user.country_id,
              province: step2data.province,
              city: step2data.city,
              area: step2data.area,
              address: step2data.addr,
              zip: step2data.zip,
              // payway_ind: step3data.payType=='delivery'?2:1,
              // is_pay: 2, // 1 已付款  2 未付款 这编写死2是因为不管怎么样都会事先建立订单在执行付款的动作，所以这编写死就好
              // bank_sn: '',
              note: step2data.remark,
            }
            console.log(postdata);

            try {
              const res = await cartsConfirm(postdata);
              // loadingInstance.close();

            } catch (error) {
              // loadingInstance.close();
              return;
            }
            break;
          case 'success':
            // 前往结帐页面
            postdata = {
              store_id: user.store_id,
              member_id: user.id,
              payway_ind: step3data.payType=='delivery'?2:1,
              // is_pay: 2, // 1 已付款  2 未付款 这编写死2是因为不管怎么样都会事先建立订单在执行付款的动作，所以这编写死就好
              // bank_sn: '',
            }
            console.log(postdata);

            try {
              const res = await cartsCheckout(postdata);
              this.cars = [];
              // loadingInstance.close();

            } catch (error) {
              // loadingInstance.close();
              return;
            }
            break;
        }
        loadingInstance.close();
        this.step = step;
        window.scrollTo({'behavior': 'smooth', 'top': 0})
      },
      doTotalCount() {
        return this.cars.reduce((currentPrice, item) => {
          return currentPrice += item.price*item.qty;
        },0);
      },
      doShipPrice() {
        const totlaCount = this.doTotalCount();
        const toteFeeRange = this.toteFeeRange
        
        let nowToteFee = 0;
        toteFeeRange.forEach((element,key) => {
          // 如果小計的價格小於freeAmt的話
          if(totlaCount < element.freeAmt) {
            nowToteFee = element.toteFee;
          }
        });

        return nowToteFee;
        // this.toteFee


        // if(totlaCount > this.freeAmt) {
        //   return 0;
        // }else{
        //   return this.toteFee;
        // }
      },
      doCouponPrice() {
        return this.couponCostPrice;
      },
      async handleChangeCoupon() {
        if(this.useCouponTemp=='') {
          this.couponCostPrice = 0;
          return;
        }
        // 看拿过coupon list了没
        if(this.couponList=='') {
          // 没拿过就先去call api
          const res = await getDiscounts({ pages:0,count:1000 });
          console.log(res.discounts);
          const canUse = res.discounts.filter(item => item.use_status==1 );
          console.log('canUse');
          console.log(canUse);
          this.couponList = canUse;
        }
        // 判断输入的优惠卷是否存在
        const coupon = this.couponList.filter(item => item.no==this.useCouponTemp);
        if(coupon.length==0) {
          this.$message({
            message: this.$('alert_message.no_coupon'),
            type: 'warning'
          });
          this.couponCostPrice = 0;
          return;
        }
        // 判断优惠卷是否适用购物车的商品
        const productIds = this.cars.reduce((currentIds,item) => {
          currentIds.push(parseInt(item.product_id));
          return currentIds;
        },[]);

        if(!productIds.includes(parseInt(coupon[0].scope))) {
          // 优惠卷的scope跟购物车的product_id没有匹配到
          this.$message({
            message: this.$t('alert_message.cant_use_coupon'),
            type: 'warning'
          });
          this.couponCostPrice = 0;
          return
        }

        // 计算使用优惠卷的价格
        this.couponCostPrice = coupon[0].amount;
        this.$message({
          message: this.$t('alert_message.use_coupon_success'),
          type: 'success'
        });
      }
    }
  }
</script>

<style lang="less" scoped>
.cart-page {
  .page-container {
    border-top: unset;
    flex-direction: column;
    @media (max-width: 992px) {
      padding-top: 0;
    }
  }
  .page-title {
    @media (max-width: 992px) {
      margin-bottom: 0;
    }
  }

  /deep/ .card-list {
    display: flex;
    margin-bottom: 100px;
  }
  /deep/ .card {
    padding: 15px;
    border: 1px solid #E6E6E6;
    margin-left: 15px;
    flex: 1;
    margin-bottom: 30px;
    &:nth-child(1) {
      margin-left: 0;
    }
    .card-title {
      font-weight: 400;
      color: black;
      padding-bottom: 15px;
      border-bottom: 1px solid #E6E6E6;
      font-size: 1.4rem;
    }
    .card-body {
      padding-top: 15px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // flex-direction: column;
      .group-info-item {
        margin-bottom: 15px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        &.flex-s {
          flex: 0 0 calc(33% - 20px);
        }
        &.flex-m {
          flex: 0 0 calc(50% - 10px);
        }
        &.flex-x {
          flex: 0 0 100%;
        }
        .item-title {
          margin-bottom: 15px;
          font-weight: 300;
          &.has-black-radio {
            padding-left: 26px;
            position: relative;
            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0px;
              height: 6px;
              width: 6px;
              border: 6px solid black;
              border-radius: 50%;
            }
            @media (max-width: 992px) {
              &::before {
                height: 6px;
                width: 6px;
                background: white;
                border: 5px solid #707070;
                border-radius: 50%;
              }
            }
          }
        }
        .item-content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          .flex-s {
            margin-bottom: 15px;
            flex: 0 0 calc(33% - 20px);
          }
          .flex-m {
            margin-bottom: 15px;
            flex: 0 0 calc(50% - 10px);
          }
          .flex-x {
            margin-bottom: 15px;
            flex: 0 0 100%;
          }
          textarea {
            height: 8rem !important;
          }
          select {
            font-size: 13px;
            padding: 6px;
          }
        }
        .read-only-input {
          border: 1px solid #707070;
          padding: 5px 15px;
          min-height: calc(1rem + 10px); // 10px是padding的上下5px
        }
      }
      .cart-info {
        position: relative;
        margin-bottom: 20px;
        flex: 0 0 100%;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
        span {
          position: absolute;
          right: 0;
        }
        &.total {
          font-size: 1.4rem;
          font-weight: 400;
          color: black;
          border-top: 1px solid #E6E6E6;
          padding-top: 20px;
          span {
            color: #FF5214;
          }
        }
        &.coupon {
          span {
            color: #0E6C9C;
          }
          .cancel {
            position: absolute;
            color: white;
            background: #0E6C9C;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            text-align: center;
            top: 50%;
            left: -30px;
            transform: translateY(-50%);
            cursor: pointer;
          }
        }
      }
      .el-date-editor {
        margin-bottom: 20px;
        flex: 0 0 100%;
      }
    }
    .card-foot {
      border-top: 1px solid #E6E6E6;
      margin-top: 20px;
      padding: 20px 0;
      .btns {
        display: flex;

      }
      .btn {
        margin-left: 40px;
        flex: 1;
        &:nth-child(1) {
          margin-left: 0;
        }
      }
    }
    @media (max-width: 992px) {
      margin-left: 0;
      background: #F7F8FA;
      margin-bottom: 15px;
      border: unset;
      .card-title {
        font-weight: 300;
        padding-bottom: 15px;
        border-bottom: 1px solid #E6E6E6;
        text-align: center;
        font-size: 1rem;
      }
      .card-body {
        .cart-info.total {
          font-weight: 300;
          font-size: 1rem;
          span {
            color: black;
          }
        }
        .group-info-item {
          .min-h-8 {
            min-height: calc(8rem + 10px);
          }
          &.flex-s {
            flex: 0 0 100%;
          }
          .read-only-input {
            border: 1px solid #E6E6E6;
          }
        }
      }
    }
  }
  /deep/ .btns {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
    .btn {
      width: 254px;
      margin-left: 20px;
      &:nth-child(1) {
        margin-left: 0;
      }
    }
    @media (max-width:992px) {
      // position: fixed;
      // bottom: 0;
      // left: 0;
      // z-index: 10;
      // margin-bottom: 0px;
      padding: 0px 20px;
      width: 100%;
      .btn {
        flex: 1;
        width: auto;
      }
    }
  }
}
</style>